/* CPL.CartItems — sepet satırı, indirim kodu ve not mantığı (<cart-drawer> ve <cart-page> ortak tabanı)
   Alt sınıf tanımlar: sectionId (getter), contentId, source, scrollSelector (isteğe bağlı), focusFallback() */
(() => {
  const CPL = (window.CPL = window.CPL || {});
  if (CPL.CartItems) return;

  class CartItems extends HTMLElement {
    connectedCallback() {
      this.live = this.querySelector('[data-cart-live]');
      try {
        this.strings = JSON.parse(this.querySelector('[data-cart-strings]').textContent);
      } catch (e) {
        this.strings = {};
      }
      this.queue = Promise.resolve();
      this.timers = {};

      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => this.onChange(e));
      this.addEventListener('input', (e) => this.onInput(e));
      this.addEventListener('submit', (e) => this.onSubmit(e));

      // Not: yeniden çizim tetiklememek için sections'sız doğrudan istek
      this.saveNote = CPL.debounce((note) => {
        fetch(window.routes.cart_update_url + '.js', CPL.fetchConfig('json', { note })).catch(() => {});
      }, 500);

      this.unsubscribe = CPL.subscribe(CPL.events.cartUpdate, (e) => this.onCartUpdate(e));
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    get content() {
      return document.getElementById(this.contentId);
    }

    get sectionId() {
      return this.content?.dataset.cartSection;
    }

    focusFallback() {
      return null;
    }

    /* Olaylar */
    onClick(e) {
      const t = e.target;
      const remove = t.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        const li = remove.closest('[data-key]');
        if (li) this.updateLine(li.dataset.key, 0);
        return true;
      }
      const setGroup = t.closest('[data-set-group]');
      if (setGroup) {
        const step = t.closest('[data-set-step]');
        if (step) {
          const qty = Math.max(0, Number(setGroup.dataset.setQty) + Number(step.dataset.setStep));
          this.updateSet(setGroup, qty);
          return true;
        }
        if (t.closest('[data-set-remove]')) {
          this.updateSet(setGroup, 0);
          return true;
        }
        const edit = t.closest('[data-set-edit]');
        if (edit) {
          // Set oluşturucu seçimi bu setle açar; yeni set eklenince eskisinin yerine geçer
          try {
            sessionStorage.setItem(
              'cpl-set-edit',
              JSON.stringify({
                id: edit.dataset.setEdit,
                qty: Number(setGroup.dataset.setQty) || 1,
                variants: (edit.dataset.setVariants || '').split(',').filter(Boolean),
              })
            );
          } catch (err) {
            /* depolama kapalıysa yalnızca sayfaya git */
          }
          const builder = document.querySelector('set-builder');
          if (builder && typeof builder.loadEdit === 'function') {
            e.preventDefault();
            if (typeof this.close === 'function') this.close();
            builder.loadEdit();
            builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          return true;
        }
      }
      const discountRemove = t.closest('[data-discount-remove]');
      if (discountRemove) {
        this.removeDiscount(discountRemove.dataset.discountRemove);
        return true;
      }
      return false;
    }

    onChange(e) {
      const input = e.target.closest('input[data-quantity]');
      if (!input) return;
      const li = input.closest('[data-key]');
      const qty = parseInt(input.value, 10);
      if (!li || Number.isNaN(qty) || qty < 0) {
        input.value = input.dataset.value;
        return;
      }
      const key = li.dataset.key;
      clearTimeout(this.timers[key]);
      // Ardışık +/- tıklarını tek isteğe topla; 0 (sil) hemen gitsin
      this.timers[key] = setTimeout(() => this.updateLine(key, qty), qty === 0 ? 0 : 350);
    }

    onInput(e) {
      const note = e.target.closest('[data-cart-note]');
      if (note) {
        const count = note.parentElement?.querySelector('[data-note-count]');
        if (count) count.textContent = `${note.value.length}/${note.maxLength > 0 ? note.maxLength : 200}`;
        this.saveNote(note.value);
        return;
      }
      if (e.target.closest('[data-discount-form] input')) this.discountError(null);
    }

    onSubmit(e) {
      const form = e.target.closest('[data-discount-form]');
      if (!form) return;
      e.preventDefault();
      this.applyDiscount(form);
    }

    /* Sepet güncellemesi → içeriği yenile */
    onCartUpdate({ sections } = {}) {
      const id = this.sectionId;
      if (!id) return;
      const html = sections && sections[id];
      if (html) this.render(html);
      else this.refresh();
    }

    async refresh() {
      const id = this.sectionId;
      if (!id) return;
      try {
        const res = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(id)}`);
        this.render(await res.text());
      } catch (e) {
        /* sessiz geç */
      }
    }

    render(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.getElementById(this.contentId);
      const current = this.content;
      if (!next || !current) return;

      // Açık details, kaydırma, not taslağı ve odağı koru
      const openKeys = Array.from(current.querySelectorAll('details[data-persist]'))
        .filter((d) => d.open)
        .map((d) => d.dataset.persist);
      next.querySelectorAll('details[data-persist]').forEach((d) => {
        if (openKeys.includes(d.dataset.persist)) d.open = true;
      });
      const note = current.querySelector('[data-cart-note]');
      const nextNote = next.querySelector('[data-cart-note]');
      if (note && nextNote) {
        nextNote.value = note.value;
        const count = next.querySelector('[data-note-count]');
        if (count) count.textContent = `${note.value.length}/200`;
      }
      const scroller = this.scrollSelector ? current.querySelector(this.scrollSelector) : null;
      const scroll = scroller ? scroller.scrollTop : 0;
      const focus = this.focusRef();

      current.replaceWith(document.adoptNode(next));

      if (this.scrollSelector) {
        const body = this.content.querySelector(this.scrollSelector);
        if (body) body.scrollTop = scroll;
      }
      if (focus) this.restoreFocus(focus);
      this.announce(this.content.dataset.liveText);
      this.afterRender();
    }

    afterRender() {}

    focusRef() {
      const a = document.activeElement;
      if (!a || !this.content || !this.content.contains(a)) return null;
      return {
        key: a.closest('[data-key]')?.dataset.key,
        name: a.dataset.focus || a.getAttribute('name'),
      };
    }

    restoreFocus({ key, name }) {
      const root = this.content;
      let el = null;
      const pick = (scope) =>
        name ? scope.querySelector(`[data-focus="${name}"]`) || scope.querySelector(`[name="${name}"]`) : null;
      if (key) {
        const li = this.lineEl(key);
        if (li) el = pick(li);
      } else {
        el = pick(root);
      }
      (el || this.focusFallback())?.focus({ preventScroll: true });
    }

    announce(text) {
      if (!this.live || !text) return;
      this.live.textContent = '';
      setTimeout(() => (this.live.textContent = text), 100);
    }

    /* Satırlar */
    lineEl(key) {
      return Array.from(this.querySelectorAll('[data-key]')).find((el) => el.dataset.key === key) || null;
    }

    setLoading(li, on) {
      if (!li) return;
      li.classList.toggle('is-loading', on);
      li.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    lineMessage(key, text, type = 'warning') {
      const li = this.lineEl(key);
      const box = li && li.querySelector('[data-line-message]');
      if (!box) return;
      box.classList.toggle('form-message--warning', type === 'warning');
      box.classList.toggle('form-message--error', type === 'error');
      box.querySelector('[data-line-message-text]').textContent = text;
      box.hidden = false;
    }

    stockText(qty) {
      return (this.strings.stock || '').replace('[quantity]', qty);
    }

    // İstekleri sıraya al; satır numarası istek anındaki DOM'dan okunur (silmeler kaydırır)
    updateLine(key, qty) {
      this.queue = this.queue.then(() => this.runLine(key, qty)).catch(() => {});
      return this.queue;
    }

    async runLine(key, qty) {
      const li = this.lineEl(key);
      if (!li) return;
      const line = Number(li.dataset.line);
      this.setLoading(li, true);
      try {
        const cart = await CPL.cart.change(line, qty, this.source);
        if (qty > 0) {
          // Shopify adedi sessizce kırptıysa da uyar
          const item = (cart.items || []).find((i) => i.key === key);
          if (item && item.quantity < qty) this.lineMessage(key, this.stockText(item.quantity));
        }
      } catch (err) {
        const fresh = this.lineEl(key) || li;
        this.setLoading(fresh, false);
        if (err && err.status === 422 && qty > 0) {
          const available = this.availableFrom(fresh, err);
          if (available > 0 && available < qty) {
            try {
              await CPL.cart.change(Number(fresh.dataset.line), available, this.source);
            } catch (e) {
              /* aşağıda mesaj yine gösterilir */
            }
            this.lineMessage(key, this.stockText(available));
            return;
          }
        }
        const input = fresh.querySelector('[data-quantity]');
        if (input) {
          input.value = input.dataset.value;
          input.closest('quantity-input')?.sync?.();
        }
        this.lineMessage(key, (err && (err.description || err.message)) || this.strings.error, 'error');
      }
    }

    /* Kendi setin: tüm satırları birlikte güncelle (0 → seti kaldır) */
    updateSet(group, qty) {
      const keys = (group.dataset.setKeys || '').split(',').filter(Boolean);
      if (!keys.length) return this.queue;
      const updates = {};
      keys.forEach((k) => (updates[k] = qty));
      this.queue = this.queue
        .then(async () => {
          this.setLoading(group, true);
          try {
            await CPL.cart.update({ updates }, this.source);
          } catch (err) {
            const fresh = this.querySelector(`[data-set-group="${CSS.escape(group.dataset.setGroup)}"]`) || group;
            this.setLoading(fresh, false);
            const box = fresh.querySelector('[data-line-message]');
            if (box) {
              box.querySelector('[data-line-message-text]').textContent =
                (err && (err.description || err.message)) || this.strings.error;
              box.hidden = false;
            }
          }
        })
        .catch(() => {});
      return this.queue;
    }

    availableFrom(li, err) {
      const max = parseInt(li.querySelector('[data-quantity]')?.dataset.max, 10);
      if (!Number.isNaN(max)) return max;
      const m = String(err.description || err.message || '').match(/\d+/);
      return m ? parseInt(m[0], 10) : 0;
    }

    /* İndirim kodu */
    appliedCodes() {
      try {
        return JSON.parse(this.querySelector('[data-discount-codes]')?.dataset.discountCodes || '[]').filter(Boolean);
      } catch (e) {
        return [];
      }
    }

    async applyDiscount(form) {
      const input = form.querySelector('input[name="discount"]');
      const code = (input.value || '').trim();
      if (!code) {
        this.discountError(this.strings.discountEmpty);
        return;
      }
      const btn = form.querySelector('button[type="submit"]');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      const same = (a) => a.toLowerCase() === code.toLowerCase();
      const codes = this.appliedCodes().filter((c) => !same(c));
      codes.push(code);
      try {
        const cart = await CPL.cart.update({ discount: codes.join(',') }, 'discount');
        const found = (cart.discount_codes || []).find((d) => same(d.code));
        if (!found || !found.applicable) {
          this.discountError((this.strings.discountInvalid || '').replace('[code]', code), code);
        }
      } catch (err) {
        this.discountError((err && (err.description || err.message)) || this.strings.error, code);
      } finally {
        const fresh = this.querySelector('[data-discount-form] button[type="submit"]');
        [btn, fresh].forEach((b) => {
          if (!b) return;
          b.classList.remove('is-loading');
          b.removeAttribute('aria-busy');
        });
      }
    }

    async removeDiscount(code) {
      const codes = this.appliedCodes().filter((c) => c.toLowerCase() !== String(code).toLowerCase());
      try {
        await CPL.cart.update({ discount: codes.join(',') }, 'discount');
      } catch (err) {
        CPL.toast({ type: 'error', text: (err && (err.description || err.message)) || this.strings.error });
      }
    }

    // text null → hatayı temizle
    discountError(text, code) {
      const form = this.querySelector('[data-discount-form]');
      if (!form) return;
      const box = form.querySelector('[data-discount-error]');
      const input = form.querySelector('input[name="discount"]');
      if (!text) {
        if (box) box.hidden = true;
        input?.removeAttribute('aria-invalid');
        return;
      }
      const details = form.closest('details');
      if (details) details.open = true;
      if (code && input) input.value = code;
      input?.setAttribute('aria-invalid', 'true');
      if (box) {
        box.querySelector('[data-discount-error-text]').textContent = text;
        box.hidden = false;
      }
      input?.focus({ preventScroll: true });
    }
  }

  CPL.CartItems = CartItems;
})();
